import defaultApi from '@/utils/request';

export default {
  // ------------- S51W2001 -----------------------------------------
  S51W2001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S06/S51/S51W2001_Load',
      params,
    });
  },

  S51W2001_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S06/S51/S51W2001_Query',
      params,
    });
  },
  S51W2001_savAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S06/S51/S51W2001_savAction',
      data,
    });
  },
  // ------------- S51W2002 -----------------------------------------
  S51W2002_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S06/S51/S51W2002_Load',
      params,
    });
  },

  S51W2002_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S06/S51/S51W2002_Query',
      params,
    });
  },
  S51W2002_savAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S06/S51/S51W2002_savAction',
      data,
    });
  },
  // ------------- S51W2003 -----------------------------------------
  S51W2003_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S06/S51/S51W2003_Load',
      params,
    });
  },
  S51W2003_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S06/S51/S51W2003_Query',
      params,
    });
  },
  S51W2003_getPagePdf(params) { // 列印頁面: 預算執行明細列表
    return defaultApi({
      method: 'get',
      url: 'S06/S51/S51W2003_getPagePdf',
      responseType: 'blob',
      params,
    });
  },
  S51W2003_doFlow(params) {
    return defaultApi({
      method: 'get',
      url: 'S06/S51/S51W2003_doFlow',
      params,
    });
  },
  S51W2003_savAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S06/S51/S51W2003_savAction',
      data,
    });
  },
  S51W2003_AttachmentViewFileUpload(data) {
    return defaultApi({
      method: 'post',
      url: 'S06/S51/S51W2003_AttachmentViewFileUpload',
      data,
    });
  },
  S51W2003_AttachmentViewFileDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S06/S51/S51W2003_AttachmentViewFileDelete',
      data,
    });
  },

  // ---------------------------------------------------------------
};
